export const LOGO_URL = "https://files.stivisto.com/file/stivisto-drive/1fe1ca18a63d95fe53508e1c09d5967c082d1fea-27e5-4a21-9679-796968c61b81.jpe";